import type { PropsWithChildren } from "react";

import type { NavDrawerContextValue } from "../hooks/useNavDrawer";
import { NavDrawerContext } from "../hooks/useNavDrawer";

export function NavDrawerProvider({
    open,
    close,
    children,
}: PropsWithChildren<NavDrawerContextValue>) {
    return (
        <NavDrawerContext.Provider value={{ open, close }}>
            {children}
        </NavDrawerContext.Provider>
    );
}
